module.exports = __webpack_public_path__ + "img/1.70357526.png";